import { render, staticRenderFns } from "./Followings.vue?vue&type=template&id=5fb7772f"
import script from "./Followings.vue?vue&type=script&lang=js"
export * from "./Followings.vue?vue&type=script&lang=js"
import style0 from "./Followings.vue?vue&type=style&index=0&id=5fb7772f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports